import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'react-admin';
import EjectedDatagrid from '../../../components/ejected/Datagrid';
import TextFieldWithPrice from '../../../components/TextFieldWithPrice';
import TextLabelWithPercantage from '../../../components/TextFieldWithPercantage';
import EjectedBooleanField from '../../../components/ejected/BooleanField';

const Datagrid = ({
  edit, create, total, ...rest
}) => (
  <EjectedDatagrid
    currentSort={{ order: 'ASC' }}
    create={create}
    edit={edit}
    width="700px"
    {...rest}
  >
    <TextField
      label="Пин"
      source="name"
      customstyles={{ width: '100px', background: '#606060' }}
    />
    <TextField source="count" label="Записи" customstyles={{ width: '64px', background: '#2C9BC3' }} cellstyles={{ color: '#2C9BC3' }} />
    <TextField source="verified" label="Подтв." customstyles={{ width: '64px', background: '#9B69DB' }} cellstyles={{ color: '#9B69DB' }} />
    <TextField source="noanswer" label="Недозв." customstyles={{ width: '64px', background: '#AC5252' }} cellstyles={{ color: '#AC5252' }} />
    <TextField source="rejected" label="Отказ" customstyles={{ width: '64px', background: '#B4B4B4' }} cellstyles={{ color: '#B4B4B4' }} />
    <TextField source="visited_callcenter" label="Приход КЦ" customstyles={{ width: '64px', background: '#3bcd83' }} cellstyles={{ color: '#3BCD83', fontWeight: 'bold' }} />
    <TextLabelWithPercantage source="ctr_call" label="CTR" customstyles={{ width: '64px', background: '#606060' }} />
    <TextField source="visited" label="Приход" customstyles={{ width: '64px', background: '#35CD59' }} cellstyles={{ color: '#35CD59', fontWeight: 'bold' }} />
    <TextLabelWithPercantage source="ctr" label="CTR" customstyles={{ width: '64px', background: '#606060' }} />
    {/*<TextFieldWithPrice source="sum" label="Сумма" customstyles={{ width: '64px', background: '#606060' }} />*/}
    <EjectedBooleanField
      source="fired"
      label="Уволен"
      customstyles={{
        background: '#B29C6A',
        width: '70px'
      }}
      color="#B29C6A"
    />
  </EjectedDatagrid>
);

Datagrid.propTypes = {
  create: PropTypes.func,
  edit: PropTypes.func,
  // users: PropTypes.array
};

export default Datagrid;



// WEBPACK FOOTER //
// ./src/pages/callcenter/statistics_callcenter/Datagrid.js